<template>
  <div class="job-modal__background" v-on:click.self="$emit('close')">
    <div class="job-modal">
      <div class="switch-animation-target">
        <div class="job-modal__heading">
          <div v-bind:class="sponsorNameNormalized" class="job-modal__heading__left">
            <a v-if="job.sponsorWebsite" v-bind:href="job.sponsorWebsite" target="_blank" rel="noreferrer">
              <div v-bind:style="backgroundLogo" class="background-logo"></div>
            </a>
            <a v-else>
              <div v-bind:style="backgroundLogo" class="background-logo"></div>
            </a>
          </div>
          <div class="job-modal__close" v-on:click="$emit('close')"></div>
        </div>
        <div class="job-modal__name">{{ job.name }}</div>
        <div class="job-modal__location">
          <img class="job-modal__location-icon" src="@/assets/icons/location.svg" />{{ job.location }}
        </div>
        <div class="job-modal__data__container">
          <div class="job-modal__short-description">
            <div class="job-modal__data">{{ job.generalDescription }}</div>
          </div>
          <div class="job-modal__details">
            <div v-if="splitArgumentByDashDelimiter(job.requirements).length !== 0">
              <div class="job-modal__description">Što očekujemo od tebe:</div>
              <div
                class="job-modal__data"
                v-for="(requirement, index) in splitArgumentByDashDelimiter(job.requirements)"
                v-bind:key="index"
              >
                <span>- {{ requirement }}</span>
              </div>
            </div>
            <div v-if="splitArgumentByDashDelimiter(job.expectations).length !== 0">
              <div class="job-modal__description">Što možeš očekivati od nas:</div>
              <div
                class="job-modal__data"
                v-for="(expectation, index) in splitArgumentByDashDelimiter(job.expectations)"
                v-bind:key="index"
              >
                <span>- {{ expectation }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="job-modal__footer">
        <a class="button-primary button-arrow" v-if="job.link" v-bind:href="job.link" target="_blank" rel="noreferrer">
          Prijavi se
        </a>
        <div v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import { sponsorLogoExtensions } from '@/config';

export default {
  name: 'JobModal',
  props: {
    job: {},
    currentIndex: Number,
    maxIndex: Number,
  },
  data() {
    return {
      sponsorLogoExtensions,
    }
  },
  computed: {
    sponsorNameNormalized: function() {
      return this.job.sponsor.replace(/\s/g, '').toLowerCase();
    },
    backgroundLogo: function() {
      return {
        backgroundImage: `url(${this.sponsorLogo})`,
      };
    },
    sponsorLogo: function() {
      // eslint-disable-next-line
      return require(`@/assets/companies/logos/${this.sponsorNameNormalized}.${
        this.sponsorLogoExtensions[this.sponsorNameNormalized]
      }`);
    },
    translatedJobType: function() {
      switch (this.job.jobType) {
        case 'FullTime':
          return 'Stalni radni odnos';
        case 'PartTime':
          return 'Honorarni radni odnos';
        case 'Student':
          return 'Studentski ugovor';
        case 'Intern':
          return 'Internship';
        default:
          return '';
      }
    },
    arrowRight: function() {
      return '../../assets/icons/arrow-right.svg';
    },
  },
  methods: {
    splitArgumentByDashDelimiter: function(arg) {
      return arg.split('- ').filter(note => note.replace(/-\s/g, '').length !== 0);
    },
  },
};
</script>

<style scoped>
.job-modal__footer a {
  text-decoration: none;
}

.background-logo {
  width: 160px;
  height: 50px;
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 30px;
}

.button-primary {
  cursor: pointer;
}

.job-modal__close {
  position: relative;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.job-modal__data__container {
  max-height: 50vh;
  overflow-y: auto;
}

.job-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 37px 56px 40px 56px;
  width: 86%;
  border-radius: 30px;
  margin: 60px auto 0 auto;
  background-color: #111f22;
  color: #ffffffcc;
  z-index: 9;
  height: 90%;
}

.job-modal__close:before,
.job-modal__close:after {
  content: '';
  position: absolute;
  width: 4px;
  height: 40px;
  background-color: #fff;
  border-radius: 2px;
  top: 0;
}

.job-modal__close::before {
  transform: translate3d(10px, 0, 0) rotate(45deg);
}

.job-modal__close::after {
  transform: translate3d(10px, 0, 0) rotate(-45deg);
}

.job-modal__background {
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(10, 24, 27, 0.8);
  z-index: 8;
}

.job-modal__heading {
  display: flex;
  justify-self: flex-start;
  justify-content: space-between;
}

.job-modal__heading__left img {
  height: 50px;
  width: 200px;
}

.job-modal__name {
  font-size: 20px;
  margin-top: 24px;
  font-weight: bold;
  color: #fff;
}

.job-modal__line {
  content: '';
  width: 3px;
  height: 100%;
  background-color: #7a8e94;
}

.job-modal__heading__left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.job-modal__location {
  display: flex;
  align-items: center;
  justify-self: flex-end;
  margin: 8px 0 20px 0;
}

.job-modal__location-icon {
  margin-right: 10px;
}

.job-modal__type {
  margin-bottom: 30px;
}

.job-modal__location,
.job-modal__data {
  font-size: 18px;
  line-height: 36px;
}

.job-modal__description {
  font-size: 20px;
  font-weight: bold;
  line-height: 36px;
  margin-bottom: 10px;
}

.type__data {
  margin-left: 10px;
}

.job-modal__short-description {
  margin-bottom: 30px;
}

.job-modal__details {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.job-modal__details > div {
  width: 45%;
}

.job-modal__footer {
  margin-top: 30px;
  display: flex;
  justify-self: center;
  justify-content: space-between;
}

.arrow-left__container,
.arrow-right__container {
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  position: absolute;
  top: calc(50% - 93px);
  padding: 30px;
  border-radius: 100%;
  background-color: #7a8e9440;
  cursor: pointer;
  z-index: 9;
}

.arrow-right,
.arrow-left {
  margin: 0;
  mask-image: url('../../assets/icons/arrow-right.svg');
  mask-size: 46px;
  width: 46px;
  height: 46px;
  transform: translateY(3px);
  background-color: #7a8e94;
}

.arrow-right__container {
  right: 2%;
}

.arrow-left__container {
  left: 2%;
}

.arrow-left {
  transform: scaleX(-1);
}

.arrow-left:hover {
  animation: arrowLeftAnimation 0.6s ease-in-out forwards;
}

.arrow-right:hover {
  animation: arrowAnimation 0.6s ease-in-out forwards;
}

@keyframes arrowLeftAnimation {
  0%,
  100% {
    transform: translate(0, 0) rotate(180deg);
  }
  50% {
    transform: translate(-5px, 0) rotate(180.02deg);
  }
}

@media screen and (max-width: 1920px) {
  .arrow-left__container,
  .arrow-right__container {
    padding: 15px;
    top: calc(50% - 38px);
  }
}

@media screen and (max-width: 1440px) {
  .arrow-right,
  .arrow-left {
    width: 20px;
    height: 20px;
    mask-size: 20px;
  }

  .arrow-left__container,
  .arrow-right__container {
    padding: 15px;
    top: calc(50% - 25px);
  }
}

@media screen and (max-width: 1024px) {
  .job-modal {
    padding: 30px;
  }

  .job-modal__heading__left {
    flex-wrap: wrap;
  }

  .job-modal__heading__left a {
    width: 80%;
  }

  .job-modal__name {
    width: 100%;
  }

  .job-modal__line {
    display: none;
  }

  .job-modal__name {
    margin: 30px 0 0 0;
    font-size: 20px;
  }

  .job-modal__data {
    display: block;
    margin-left: 0;
  }

  .job-modal__data__container {
    max-height: 45vh;
  }

  .job-modal__short-description {
    padding-right: 0;
  }

  .job-modal__details {
    padding-right: 0;
    flex-wrap: wrap;
    overflow: visible;
  }

  .job-modal__details > div {
    width: 100%;
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 768px) {
  .job-modal {
    margin: 10px auto;
    height: 90%;
  }

  .arrow-left__container,
  .arrow-right__container {
    top: unset;
    bottom: 10px;
    padding: 10px;
  }

  .arrow-left,
  .arrow-right {
    width: 24px;
    height: 24px;
    mask-size: 24px;
  }

  .arrow-left__container {
    left: unset;
    right: calc(6% + 64px);
  }

  .arrow-right__container {
    right: 6%;
  }

  .arrow-left {
    transform: scaleX(-1);
  }
}

@media screen and (max-width: 440px) {
  .job-modal__data__container {
    max-height: 50vh;
  }

  .job-modal__footer__controls {
    width: 100px;
  }
}

@media screen and (max-height: 600px) {
  .job-modal__data {
    font-size: 16px;
  }

  .job-modal__description {
    font-size: 18px;
  }

  .job-modal__location {
    margin: 10px 0;
  }

  .job-modal__details > div {
    margin-bottom: 0;
  }
}
</style>
